// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Link = require("next/link").default;
var Icon__Jsx3 = require("../../atoms/Icon/Icon__Jsx3.bs.js");
var Next__Image = require("../../../../reason/next/Next__Image.bs.js");
var ReactRender = require("../../../../reason/utils/ReactRender.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../../reason/common/Theme/Theme__Color__Vars.bs.js");

function UIKit__VerticalCard(props) {
  var media = props.media;
  var tmp;
  if (media.TAG === "Image") {
    var match = media._0;
    tmp = JsxRuntime.jsx(Next__Image.make, {
          src: match.src,
          width: match.width,
          height: match.height,
          unoptimized: true,
          alt: match.alt,
          className: "object-center object-cover max-w-full h-auto"
        });
  } else {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Icon__Jsx3.make, {
                icon: media._0,
                size: 78,
                color: Theme__Color__Vars.gray
              }),
          "aria-hidden": true,
          className: "bg-zinc-200 flex flex-1 items-center justify-center min-h-[293px]"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: "p-3 order-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        ReactRender.fromOption(props.mediaLink, (function (href) {
                                return JsxRuntime.jsx(Link, {
                                            href: href,
                                            className: "absolute inset-0 z-20",
                                            "aria-hidden": true,
                                            tabIndex: -1
                                          });
                              })),
                        tmp,
                        ReactRender.fromOption(props.topLeftLabels, (function (labels) {
                                return JsxRuntime.jsx("div", {
                                            children: labels,
                                            className: "absolute top-2 left-2"
                                          });
                              })),
                        ReactRender.fromOption(props.topRightLabels, (function (labels) {
                                return JsxRuntime.jsx("div", {
                                            children: labels,
                                            className: "absolute top-2 right-2"
                                          });
                              })),
                        ReactRender.fromOption(props.mediaTextOverlay, (function (text) {
                                return JsxRuntime.jsx("div", {
                                            children: text,
                                            className: "flex bg-[#5a5a59bf] h-[30px] items-center py-0.5 px-4 text-white text-[13px] leading-[1.25] absolute left-0 right-0 bottom-0"
                                          });
                              }))
                      ],
                      className: "flex-1 flex relative order-1"
                    })
              ],
              className: "bg-white flex rounded-md overflow-hidden flex-col border border-gray-200 shadow-sm relative [will-change:box-shadow,transform] transition duration-150 ease-in hover:-translate-y-px hover:shadow-lg focus-within:z-20"
            });
}

var make = UIKit__VerticalCard;

exports.make = make;
/* next/link Not a pure module */
